import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarLeftShow12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSidebarLeftShow12Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 2h5.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H5zm7 .5A1.5 1.5 0 0 0 10.5 1h-9c-.456 0-.865.204-1.14.526H.352v.009C.132 1.795 0 2.132 0 2.5v7A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5zM6.661 4.586a.5.5 0 1 1 .707-.707l1.768 1.768L9.49 6l-.354.354-1.768 1.768a.5.5 0 1 1-.707-.708L8.075 6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarLeftShow12Filled);
